export default () => 47
